/**
 * Variante e orientação do card — PURO e SEM `"use client"`, de propósito.
 *
 * Estas duas funções viviam em `ProductCard.tsx`, que é um módulo
 * `"use client"`. Conviviam bem enquanto só componentes de cliente as
 * chamavam. Quando um Server Component passou a chamar `cardOrientation()`
 * para escolher a largura do trilho (ProductCollection), o render do servidor
 * quebrou com:
 *
 *   Attempted to call cardOrientation() from the server but cardOrientation
 *   is on the client.
 *
 * No browser o erro chega MASCARADO como "Minified React error #441" — a
 * mensagem real só aparece no log do pod. Diagnóstico caro para uma função de
 * uma linha.
 *
 * A regra: função pura que os dois lados usam não mora em módulo de cliente.
 * O `ProductCard.tsx` reexporta as duas para quem já importava de lá.
 */
import type { ProductCardVariantKey } from "@dionatanbig2be/big2be-ui";

export type { ProductCardVariantKey };

/** Variantes DEITADAS do DS — as demais são em pé. */
const HORIZONTAL = new Set<ProductCardVariantKey>(["variant-2", "variant-4", "variant-5"]);

/** template do tema ("variant2", "variant-4") → chave da variante do DS. */
export function normalizeVariant(template?: string): ProductCardVariantKey {
    const key = template?.trim().toLowerCase().replace(/^variant-?/, "");
    return key && "12345".includes(key) ? (`variant-${key}` as ProductCardVariantKey) : "variant-default";
}

/** Deitado (imagem à esquerda) ou em pé (imagem no topo). */
export type CardOrientation = "horizontal" | "vertical";

/** Orientação da variante — decide as colunas da grade e o `block` do card. */
export function cardOrientation(variant: ProductCardVariantKey): CardOrientation {
    return HORIZONTAL.has(variant) ? "horizontal" : "vertical";
}
